<script setup lang="ts">
const { tt } = useTypedI18n();
</script>

<template>
    <BaseTooltip :text="tt('signup.hint.phone.rule')">
        <p ref="trigger" class="flex flex-row items-center gap-x-1">
            {{ tt('signup.hint.phone.text') }} <UIcon class="text-primary mx-1 my-auto" name="lucide:info" />
        </p>
    </BaseTooltip>
</template>
